import BaseManager from 'managers/base.manager';
import EventsManager from 'managers/events.manager';
import { DefineOwnModule } from 'stores/type';
import { State, Getters, Actions, Mutations } from './types';

const moduleState: State = {
  elementsUpdated: -1,
};

const storeModule: DefineOwnModule<State, Getters, Mutations, Actions> = {
  state: moduleState,

  getters: {
    // HACK
    // make it dependent on reactive property
    // so that getter value is recalculated every time 'elementsUpdated' changes
    elements: (state) => {
      if (state.elementsUpdated === -1) return {};

      return BaseManager.elements;
    },
    elementsIds: (_state, getters) => Object.keys(getters.elements),
    elementsList: (_state, getters) => Object.values(getters.elements),
    elementById: (_state, getters) => (rawId) => {
      const id = `${ rawId }`;
      if (!getters.elements.hasOwnProperty(id)) {
        return null;
      }

      return getters.elements[id];
    },
    descriptionById: () => (rawId) => BaseManager.getDescriptionById(rawId),
    hasElement: (_state, getters) => (rawId) => {
      const id = `${ rawId }`;
      return getters.elements.hasOwnProperty(id);
    },
    baseElementsIds: (_state, getters) => getters.elementsList
      .filter(({ base }) => base)
      .map(({ id }) => id),

    elementsCount: (_state, getters) => getters.elementsIds.length,
    connectionsCount: (_state, getters) =>
      getters.elementsList.reduce((count, element) => count + element.parents.length, 0),
  },

  actions: {
    init({ dispatch }) {
      dispatch('baseLoad');
    },
    async baseLoad({ dispatch }) {
      const elements = await BaseManager.loadBase();
      dispatch('baseLoaded', elements);

      // load descriptions and tags when everything else is done
      await EventsManager.onReady();
      await BaseManager.loadDescriptions();
      EventsManager.emit('ENCYCLOPEDIA_DESCRIPTIONS');
      await BaseManager.loadTags();
      EventsManager.emit('ENCYCLOPEDIA_TAGS');
    },
    baseLoaded({ commit, dispatch }) {
      commit('ELEMENTS_SET');
      EventsManager.emit('ENCYCLOPEDIA_ELEMENTS');
      dispatch('progressCalculate');
    },
    baseElementsAdd({ commit, getters }, elements) {
      elements.forEach((element) => {
        if (getters.elements.hasOwnProperty(element.id)) {
          return;
        }

        BaseManager.elementAdd(element.id, element);
      });

      commit('ELEMENTS_ADD');
      EventsManager.emit('ENCYCLOPEDIA_ELEMENTS');
    },
    baseElementAdd({ commit, getters }, element) {
      if (getters.elements.hasOwnProperty(element.id)) {
        return;
      }

      BaseManager.elementAdd(element.id, element);
      commit('ELEMENTS_ADD');
    },
    baseElementsRemove({ commit, getters }, elementsIds) {
      elementsIds.forEach((id) => {
        if (!getters.elements.hasOwnProperty(id)) {
          return;
        }

        BaseManager.elementRemove(id);
      });

      commit('ELEMENTS_REMOVE');
      EventsManager.emit('ENCYCLOPEDIA_ELEMENTS');
    },
    baseElementRemove({ commit, getters }, id) {
      if (!getters.elements.hasOwnProperty(id)) {
        return;
      }

      BaseManager.elementRemove(id);
      commit('ELEMENTS_REMOVE');
    },
  },

  mutations: {
    ELEMENTS_SET(state) {
      state.elementsUpdated = Date.now();
    },
    ELEMENTS_ADD(state) {
      state.elementsUpdated = Date.now();
    },
    ELEMENTS_REMOVE(state) {
      state.elementsUpdated = Date.now();
    },
  },
};

export default storeModule;
